import React from 'react'
import { NavLink } from 'react-router-dom';
import NikeDATA from '../NikeData'

const ProductNike = () => {
    const cardItem = (item) => {
        return (
            <div class="card my-5 py-4" key={item.id} style={{width: "18rem"}}>
                <img src={item.img} class="card-img-top" alt={item.title}/>
                    <div class="card-body text-center">
                        <h5 class="card-title">{item.title}</h5>
                        <p className="lead" style={{color: '#3d40dd'}} >${item.price}</p>
                        <NavLink to={`/products/${item.id}`} class="btn btn-outline-primary">Add To Cart</NavLink>
                        
                    </div>
            </div>
                );
    }
                return (
                <div>
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h1>Featured products: Nike</h1>
                            <div align="left" className="container">
                                <NavLink to="/products"><button className="btn btn-outline-dark mx-1 " style={{width:120}}>All Products</button></NavLink>
                                <NavLink to="/productsNike" className="btn btn-outline-dark mx-1 disabled" tabindex="-1" role="button" aria-disabled="true" style={{width:100}}>Nike</NavLink>
                                <NavLink to="/productsAdidas"><button className="btn btn-outline-dark mx-1 " style={{width:100}}>Adidas</button></NavLink>
                                {/*<a href="/productsNike" className="btn btn-outline-dark disabled" tabindex="-1" role="button" aria-disabled="true" style={{width:100}}>Nike</a> 
                                <a href="/productsAdidas"><button className="btn btn-outline-dark mx-3 " style={{width:100}} >Adidas</button></a>*/}
                            </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-around">
                            {NikeDATA.map(cardItem)}
                        </div>
                    </div>

                    

                </div>
                )
}

export default ProductNike
